export default function modal(name) {
	return {
		computed: {
			show: {
				get() {
					return this.$store.state.modals[name]
				},
				set(value) {
					const action = 'modals/' + (value ? 'show' : 'hide')
					this.$store.commit(action, name)
				}
			}
		}
	}
}
